import { render, staticRenderFns } from "./PublicCustomerTwilioMessages.vue?vue&type=template&id=68d371f6&"
import script from "./PublicCustomerTwilioMessages.vue?vue&type=script&lang=js&"
export * from "./PublicCustomerTwilioMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports